import axios from 'axios'
import { store } from 'src/client'
import {
  BulkInviteResponse,
  SaveBulkInviteMappingRequest,
  SendBulkInvitesRequest,
  UploadBulkInviteResponse,
} from 'src/queries/bulkInvite/bulkInvite.models'
import {
  selectAuthedFormApiRequestConfig,
  selectAuthedJsonApiRequestConfig,
} from 'src/redux/selectors/axios.selectors'

// Upload a CSV as multipart/form-data (file part name `file`). Returns the
// freshly-created DRAFT bulk invite with the backend-detected headers.
export const uploadBulkInvite = async (
  organizationId: string,
  file: File,
): Promise<UploadBulkInviteResponse> => {
  const requestConfig = selectAuthedFormApiRequestConfig(store.getState())
  const formData = new FormData()
  formData.append('file', file)
  const response = await axios.post<UploadBulkInviteResponse>(
    `/organizations/${organizationId}/bulk-invites`,
    formData,
    requestConfig,
  )
  return response.data
}

// Persist the CSV-header → Extend-field mapping. Backend recomputes the preview
// (per-row categories + summary) and returns the full resource.
export const saveBulkInviteMapping = async (
  organizationId: string,
  bulkInviteId: string,
  body: SaveBulkInviteMappingRequest,
): Promise<BulkInviteResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())
  const response = await axios.put<BulkInviteResponse>(
    `/organizations/${organizationId}/bulk-invites/${bulkInviteId}/mapping`,
    body,
    requestConfig,
  )
  return response.data
}

// Queue the invites. The body must include exactly every current VALID_NET_NEW
// row; the backend transitions the resource to SENDING and works it async.
export const sendBulkInvites = async (
  organizationId: string,
  bulkInviteId: string,
  body: SendBulkInvitesRequest,
): Promise<BulkInviteResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())
  const response = await axios.post<BulkInviteResponse>(
    `/organizations/${organizationId}/bulk-invites/${bulkInviteId}/send`,
    body,
    requestConfig,
  )
  return response.data
}

// Read the current state of a bulk invite. Polled until a terminal status.
export const fetchBulkInvite = async (
  organizationId: string,
  bulkInviteId: string,
): Promise<BulkInviteResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())
  const response = await axios.get<BulkInviteResponse>(
    `/organizations/${organizationId}/bulk-invites/${bulkInviteId}`,
    requestConfig,
  )
  return response.data
}
